module.exports = __webpack_public_path__ + "static/media/agility.c11279bf.png";